import type { QuizDetail, QuizUpdateRequest } from '@cfa/pathway-fe-shared/xp';

import type { EditableQuizDetail } from './quizEditorTypes';

type QuizUpdateSource = QuizDetail | EditableQuizDetail;

export const quizDetailToUpdateBody = (
  quizDetails: QuizUpdateSource,
  overrides: Partial<EditableQuizDetail> = {},
): EditableQuizDetail => ({
  formId: quizDetails.formId,
  name: quizDetails.name,
  ownerId: quizDetails.ownerId,
  passingGrade: quizDetails.passingGrade,
  quizId: quizDetails.quizId,
  questions: quizDetails.questions,
  ...overrides,
});

export const toQuizUpdateRequest = (
  quizDetails: QuizUpdateSource,
  overrides: Partial<EditableQuizDetail> = {},
): QuizUpdateRequest => {
  const mapped = quizDetailToUpdateBody(quizDetails, overrides);

  const passingGrade =
    typeof mapped.passingGrade === 'string'
      ? Number(mapped.passingGrade)
      : mapped.passingGrade;

  if (passingGrade == null || !Number.isFinite(passingGrade)) {
    throw new Error('Quiz update requires passingGrade');
  }

  const nameEn = mapped.name.en;
  if (typeof nameEn !== 'string' || nameEn === '') {
    throw new Error('Quiz update requires name');
  }

  if (!Array.isArray(mapped.questions)) {
    throw new Error('Quiz update requires questions');
  }

  return {
    name: mapped.name,
    passingGrade,
    questions: mapped.questions,
  };
};
